<template>
  <div :class="$style.layout">
    <main v-if="!items.length">
      <h2 class="title-strat">
        {{ noResultText }}
      </h2>
    </main>
    <main
      v-else
      :class="$style.container"
    >
      <div
        v-for="item in items"
        :key="item.id"
        :class="$style.item"
      >
        <WaperOpinionItem :opinion="item" />
      </div>
    </main>
  </div>
</template>

<script setup lang="ts">
import type { Opinion } from '~/types'

withDefaults(
  defineProps<{
    items: Opinion[]
    noResultText?: string
  }>(),
  {
    noResultText: 'Aucun contenu',
  },
)
</script>

<style lang="scss" module>
.layout {
  padding: 0 2.5rem;

  @media (min-width: 700px) {
    max-width: 200rem;
    margin: 0 auto;
    padding: 0 8rem;
    overflow: hidden;
  }
}

.container {
  display: flex;
  flex-wrap: wrap;

  @media (min-width: 992px) {
    margin: 0 -3rem;
  }

  @media (min-width: 1240px) {
    margin: 0 -4rem;
  }

  @media (min-width: 1600px) {
    margin: 0 -12rem;
  }
}

.item {
  display: flex;
  flex-basis: 100%;
  padding: 5rem 0;
  border-bottom: 1px solid #d1d1d1;

  @media (max-width: 991px) {
    &:first-child {
      padding-top: 0;
    }
  }

  @media (min-width: 992px) {
    flex-basis: 50%;
    padding: 6rem 3rem;

    &:nth-child(odd) {
      border-right: 1px solid #d1d1d1;
    }
  }

  @media (min-width: 1240px) {
    padding: 6rem 4rem;
  }

  @media (min-width: 1600px) {
    padding: 6rem 12rem;
  }
}
</style>
